import { Controller } from "@hotwired/stimulus";

/** GO4S DS — pilule sélectionnable (bascule aria-pressed). */
export default class extends Controller {
  toggle() {
    const on = this.element.getAttribute("aria-pressed") === "true";
    this.element.setAttribute("aria-pressed", String(!on));
  }
}
